var isObject=function(a){return"[object Object]"===Object.prototype.toString.call(a)};export default isObject;